module.exports = __webpack_public_path__ + "img/3-4.61f035b5.svg";